import styled from 'styled-components';

export const SkeletonItemWrapper = styled.div`
  width: 100%;
  height: 313px; /* match TourListingCard height */
  background-color: ${({ theme }) => theme.palette.white};
  display: flex;
  margin-bottom: 10px;
  position: relative;
  box-shadow: 0px 0px 8px rgba(0, 17, 68, 0.08); /* match card */
  border-radius: 8px;
  overflow: hidden;
  flex-direction: row;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    flex-direction: column;
    height: auto; /* auto like TourListingCard */
  }
`;

export const SkeletonItemFeatureWrapper = styled.div`
  display: flex;
  margin-bottom: 10px;
`;

export const SkeletonItemHeader = styled.div`
  margin-bottom: 12px; /* align with TourDetails spacing */
  display: flex;
  flex-direction: row;
  gap: 12px;
  flex-wrap: nowrap;
`;
export const SkeletonItemInfo = styled.div`
  margin-bottom: 20px;
`;

export const SkeletonItemMain = styled.div`
  padding: 24px; /* sync with TourListingCard */
  flex: 1; /* allow content to fill like ContentWrapper */
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 16px;
  }
`;

export const SkeletonItemDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.palette.grey300};
  margin: 16px 0;
  position: static;
  right: auto;
  top: auto;
  transform: none;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    display: none; /* hide divider on mobile like TourDivider */
  }
`;

export const MobileSkeletonItemWrapper = styled.div`
  width: 100%;
  height: auto; /* auto to mirror responsive card */
  min-height: 0;
  background-color: ${({ theme }) => theme.palette.white};
  margin-bottom: 10px;
  position: relative;
  overflow: hidden;
  box-shadow: 0px 0px 8px rgba(0, 17, 68, 0.08);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
`;

export const MobileSkeletonItemContent = styled.div`
  margin: 10px;
`;

export const MobileSkeletonItemPrice = styled.div`
  position: absolute;
  bottom: 24px;
  right: 15px;
`;
